<style src="./style.scss">

</style>

<main id="dnsPage" class="mbsc-grid d-ns-page checkout-page">
</main>

<script>
import { onMount, afterUpdate } from 'svelte';
import { loadStripe } from '@stripe/stripe-js';
import { Stripe, Navigation, AWSAuth, AWSAnalytics } from '@Services';

export let router = null;

const DEBUG = document.location.protocol === 'http:' ? true : false;

let member = null;
let stripeSessionId = null;
let stripeInstance = null;

afterUpdate(() => {
  member = AWSAuth.getUser();
  if (DEBUG) console.log('[MyAccount] member: ' + member);
  if (typeof member !== 'string') {
    let sessionMethod = Stripe.getMonthlyId();
    if (router.params.item === 'monthly') {
      sessionMethod = Stripe.getMonthlyId();
    } else if (router.params.item === 'yearly') {
      sessionMethod = Stripe.getYearlyId();
    }
    sessionMethod.then(async (response)=>{
      stripeSessionId = response.session.id;
      const stripe = await loadStripe('pk_live_krwg6YfJKkxHhwhSwhsKpDrP002CPU8eSh');
      const {error} = await stripe.redirectToCheckout({
        sessionId: stripeSessionId
      });
    });
  }else{
    Navigation.goTo('account');
  }
});

onMount(async () =>{});
</script>
